<template>
  <main>
    <wl-banner bgUrl='/static/img/product/jsxm/banner.png' :bannerData='bannerData'></wl-banner>
    <breadcrumb></breadcrumb>
    <section class="page1 bg" v-lazy:background-image="'/static/img/product/jsxm/page1.png'">
      <article class="container flex">
        <wl-title :title='page1Data.title' :desc='page1Data.desc' class="mytitle"></wl-title>
      </article>
    </section>
    <section class="page2 bg" v-lazy:background-image="'/static/img/product/jsxm/page2.png'">
    </section>
    <section class="page3 bg" v-lazy:background-image="'/static/img/product/jsxm/page3.png'">
      <article class="container">
        <wl-title title='建设项目全生命周期管理' :isNeedDesc=false></wl-title>
        <section class="box" v-for="(item,index) in page3Data" :key="index">
          <h3>{{item.title}}</h3>
        </section>
      </article>
    </section>
    <submit-page></submit-page>
  </main>
</template>

<script>
export default {
  name: 'jsxmManageSystem',
  data() {
    return {
      bannerData: {
        title: '实验室建设项目管理系统',
        desc: '规范管理实验室项目建设过程\n提高实验室建设质量'
      },
      page1Data: {
        title: '实验室建设项目管理系统',
        desc: '系统可实现对实验室建设项目的网上在线申报、评审、立项、经费下拨、项目实施等进行流程化管理,根据收集的数据与设置的评价系统,对各类建设项目进行效益分析,可对实验室专项建设中所涉及的设备、实验室、人员等基础信息进行综合查询。'
      },
      page3Data: [
        { title: '项目前期，申报立项一目了然' },
        { title: '项目中期，实施进度多维管控' },
        { title: '项目后期，验收效益精准评估' },
      ],
    }
  },
  methods: {
  }
}
</script>

<style lang='scss' scoped>
main {
  background: #fbfbff;
  text-align: left;
}
.page1 {
  height: 579px;
  padding-top: 164px;
  text-align: left;
  .mytitle {
    width: 600px;
    margin-left: 670px;
    ::v-deep strong {
      color: #8e8e8e;
      line-height: 38px;
      padding-top: 23px;
    }
  }
}
.page2 {
  height: 986px;
}
.page3 {
  height: 677px;
  padding-top: 223px;
  h3 {
    padding: 0;
    font-size: 24px;
    font-weight: 500;
    color: #262626;
    line-height: 24px;
  }
  .container {
    .box {
      padding-left: 52px;
      padding-bottom: 51px;
      &:nth-child(2) {
        padding-top: 75px;
      }
    }
  }
}
</style>
